import AuthTypes from "../types/authTypes";
import {
  INDIAN_MSME_USER_ID,
  INDIAN_MSME_USER_TOKEN,
} from "../../utils/Constants";
import { getCookie, removeCookie, storeCookie } from "../../utils/CookieAction";
import ProfileType from "../types/profileType";

export interface AuthState {
  profileDetails: any;
  authenticated: boolean;
  token: any;
}

interface ReducerAction {
  type: string;
  payload?: any;
  token?: any;
}

const INITIAL_STATE: AuthState = {
  profileDetails: null,
  authenticated: false,
  token: null,
};

const AuthReducer = (state = INITIAL_STATE, action: ReducerAction) => {
  switch (action.type) {
    case AuthTypes.RESET_AUTH:
      removeCookie(INDIAN_MSME_USER_TOKEN);
      removeCookie(INDIAN_MSME_USER_ID);
      return INITIAL_STATE;

    case AuthTypes.SET_USER:
      storeCookie(INDIAN_MSME_USER_TOKEN, JSON.stringify(action.token));
      storeCookie(INDIAN_MSME_USER_ID, JSON.stringify(action.payload.id));
      return {
        ...state,
        profileDetails: action.payload,
        authenticated: true,
        token: action.token,
      };

    case AuthTypes.BS_PANEL_ACCESS:
      storeCookie(INDIAN_MSME_USER_TOKEN, JSON.stringify(action.token));
      storeCookie(INDIAN_MSME_USER_ID, JSON.stringify(action.payload.id));

      return {
        ...state,
        profileDetails: action.payload,
        authenticated: true,
        token: action.token,
      };

    case ProfileType.SET_PROFILE_DETAILS:
      const userData: any = action.payload;

      return {
        ...state,
        profileDetails: userData,
      };

    case ProfileType.BECOME_A_SELLER:
      const data: any = { ...state.profileDetails };
      data.become_a_seller = "1";
      return {
        ...state,
        profileDetails: data,
      };

    case ProfileType.SET_USER_TYPE:
      const user: any = { ...state.profileDetails };
      user.user_type = action.payload;
      return {
        ...state,
        profileDetails: user,
      };

    default:
      return state;
  }
};

export default AuthReducer;
